// removed by extract-text-webpack-plugin
module.exports = {"formGroup":"FieldRadioGroup__formGroup"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FieldRadioGroup/FieldRadioGroup.scss
// module id = ./src/components/FieldRadioGroup/FieldRadioGroup.scss
// module chunks = 2